import { ensureDefined } from '@e-socna/utils';

import { useGraphQLQuery } from '../../../../hooks/useGraphQLQuery.hook';

import { NoData } from '../../../Illustrations/NoData';
import { Loading } from '../../../Loading';
import { Versions } from '../../../Versions';

import { useDocumentEditorContext } from '../../contexts/DocumentEditorContext/hooks/useDocumentEditorContext.hook';
import type { Editable } from '../../types/editable.type';

export const VersionsTabPanel = () => {
  const {
    props: {
      getters: { versions },
    },
    state: { editable },
  } = useDocumentEditorContext<Editable>();

  const { getVersions } = ensureDefined({ getVersions: versions });

  const { queryDocument } = getVersions(editable);

  const { data, isSuccess } = useGraphQLQuery(queryDocument, {
    originalId: editable._id,
  });

  if (isSuccess) {
    const { findAllEditableVersionsForOneOriginalId: versions } = data;

    return versions.length ? <Versions versions={versions} /> : <NoData />;
  }

  return <Loading />;
};
